module.exports = __webpack_public_path__ + "img/purchase7.a889c6cb.png";